import BaseFormPresenter from "../../../../base/BaseFormPresenter";
import { findObjectUseCase } from "../../../../usecases/object";
import {
  normalizeDate,
  getDatesInRange,
} from "../../../../components/common/Converter";
import { parseTimeLogs } from "../../../../components/common/Converter";

class PayrollFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  async getFetchData() {
    const { objects1, startDate, endDate, employeeID, payrollType, selected } =
      this.view.props;

    const individual = objects1.filter((item) => item.id === employeeID);
    const dataMapping =
      payrollType === "Individual Payroll" ? selected : objects1;

    const start = new Date(startDate);
    const end = new Date(endDate);
    const dateRange = getDatesInRange(start, end);
    const normalizedStart = normalizeDate(start);
    const normalizedEnd = normalizeDate(end);

    let ids = [],
      schedules = [],
      listOfScheds = [];
    const getScheduleDays = (schedule) => {
      return Array.isArray(schedule)
        ? schedule.map((entry) => entry.day.toLowerCase())
        : [];
    };
    const schedules1 = dataMapping.map(({ id, selectedSchedule }) => ({
      employeeId: id,
      schedule: new Set(getScheduleDays(selectedSchedule?.scheduleArray)),
    }));

    for (const { id, selectedSchedule } of dataMapping) {
      const scheduleList = selectedSchedule?.scheduleArray;
      const employeeSched = selectedSchedule?.scheduleArray?.map((entry) =>
        entry?.day.toLowerCase()
      );

      ids.push(id);
      schedules.push({
        id: id,
        schedule: employeeSched ?? " ",
      });
      listOfScheds.push({ schedules: scheduleList ?? " ", id: id });
    }

    console.log("SCHEDSSS", schedules1);

    console.log("datass", dataMapping);
    // for (const { id, schedule } of dataMapping) {
    //   const scheduleList = schedule;
    //   const employeeSched = schedule?.map((entry) => entry?.day.toLowerCase());

    //   ids.push(id);
    //   schedules.push({
    //     id: id,
    //     schedule: employeeSched ?? " ",
    //   });
    //   listOfScheds.push({ schedules: scheduleList ?? " ", id: id });
    // }

    console.log("schedules", schedules);
    console.log("listOfScheds", listOfScheds);

    const [empLogs, empLeaves, suspension, holidays, lateUndertime] =
      await Promise.all([
        findObjectUseCase().execute("daily_time_record", {
          where: {
            "employee.id": { $in: ids },
            timeRecStats: { $in: ["LATE", "UNDERTIME"] },
          },
        }),
        findObjectUseCase().execute("leave_request", {
          where: {
            "employee.id": { $in: ids },
            stats: "Approved",
          },
        }),
        findObjectUseCase().execute("suspension"),
        findObjectUseCase().execute("holidays"),
        findObjectUseCase().execute("daily_time_record", {
          include: ["employee.selectedSchedule"],
          where: {
            "employee.id": { $in: ids },
            timeRecStats: { $in: ["LATE", "UNDERTIME"] },
          },
        }),
      ]);

    console.log("EMPLOYEEE LATE UNDERTIME", lateUndertime);
    // const currentDay = new Date().toLocaleString("en-us", { weekday: "long" });
    // for (const item of lateUndertime) {
    //   const scheduleForToday =
    //     item?.employee?.selectedSchedule?.scheduleArray.find(
    //       (sch) => sch.day === currentDay
    //     );
    //   console.log("scheduleForToday", scheduleForToday);

    //   const timeInForToday = sched?.timein || "0";
    //   const timeOutForToday = sched?.timeout || "0";
    // }

    const workingDaysCount = schedules.map((sched) => {
      // const count =
      //   dateRange?.filter((date) => sched?.schedule?.includes(date))?.length ??
      //   0;
      // return {
      //   id: sched?.id,
      //   workingDays: count,
      // };
    });

    const weekEndsOff = schedules.map((sched) => {
      const count =
        dateRange?.filter((date) => !sched?.schedule?.includes(date))?.length ??
        0;

      return {
        id: sched?.id,
        excludedDays: count,
      };
    });

    const halfHoursCount = listOfScheds?.map((sched) => {
      const scheduledHours = Array.isArray(sched.schedules)
        ? sched.schedules.map((d) => {
            if (d.duration) {
              return parseInt(d.duration.split(" ")[0], 10) / 2;
            }
            return 0;
          })
        : [];

      return {
        id: sched.id,
        scheduledHours: scheduledHours,
      };
    });

    let logsByEmployee = [];
    const filteredLogs = [];
    const validLogs = [];
    let count = [];

    for (const id of ids) {
      let employeeCount = 0;
      for (const log of empLogs) {
        const logDate = new Date(log?.date);
        const normalized = normalizeDate(logDate);
        if (
          log?.employee?.id === id &&
          normalized >= normalizedStart &&
          normalized <= normalizedEnd
        ) {
          filteredLogs.push(log);
        }
        if (
          log?.employee?.id === id &&
          normalized >= normalizedStart &&
          normalized <= normalizedEnd &&
          log?.timeIn !== "--:--" &&
          log?.timeOut !== "--:--"
        ) {
          const timeInHours = parseTimeLogs(log?.timeIn);
          const timeOutHours = parseTimeLogs(log?.timeOut);
          const workedHours = (timeOutHours - timeInHours) / (1000 * 60 * 60);
          if (
            halfHoursCount
              ?.find((item) => item.id === log?.employee?.id)
              ?.scheduledHours?.includes(workedHours)
          ) {
            employeeCount++;
          }
          validLogs.push(log);
        }
      }
      count[id] = employeeCount;
    }

    const filterLeaves = [];
    for (const employeeId of ids) {
      for (const leave of empLeaves) {
        const start = new Date(leave?.startdate);
        const end = new Date(leave?.enddate);
        const startDate = normalizeDate(start);
        const endDate = normalizeDate(end);
        if (
          leave?.employee?.id === employeeId &&
          startDate >= normalizedStart &&
          endDate <= normalizedEnd
        ) {
          const numericalDuration = leave?.duration
            ? parseInt(leave?.duration?.match(/\d+/)?.[0] || "0", 10)
            : 0;

          filterLeaves.push(numericalDuration);
        }
      }
    }

    let filterSuspension = [];

    for (const suspend of suspension) {
      const suspendStart = normalizeDate(suspend?.dateFrom);
      const suspendEnd = normalizeDate(suspend?.dateTo);

      if (suspendStart >= normalizedStart && suspendEnd <= normalizedEnd) {
        const daysOfWeek = [];
        let currentDate = new Date(suspendStart);
        let endDate = new Date(suspendEnd);

        while (currentDate <= endDate) {
          daysOfWeek.push(
            currentDate
              .toLocaleString("en-us", {
                weekday: "long",
              })
              .toLowerCase()
          );
          currentDate.setDate(currentDate.getDate() + 1);
        }

        filterSuspension.push(suspend);
      }
    }

    let suspensionList = 0;
    const countedSuspension = schedules?.map((i) => {
      const suspendCount = filterSuspension.map((suspend) => {
        const isSuspended =
          i?.schedule && Array.isArray(i.schedule)
            ? i.schedule.some((schedule) =>
                suspend?.daysOfWeek?.includes(schedule)
              )
            : false;

        if (isSuspended) {
          const suspendStart = normalizeDate(suspend?.dateFrom);
          const suspendEnd = normalizeDate(suspend?.dateTo);
          empLogs.forEach((item) => {
            const logDate = new Date(item?.date);
            const normalized = normalizeDate(logDate);
            if (
              item?.employee?.id === i?.id &&
              normalized >= suspendStart &&
              normalized <= suspendEnd
            ) {
              suspensionList++;
            }
          });
          return suspensionList;
        }
      });
      return { id: i.id, suspensionList };
    });

    const holidaysDate = [];
    for (const holiday of holidays) {
      const logDate = new Date(holiday?.date);
      const normalized = normalizeDate(logDate);
      if (normalized >= normalizedStart && normalized <= normalizedEnd) {
        holidaysDate.push({
          ...holiday,
          dayOfWeek: new Date(holiday?.date)
            .toLocaleString("en-us", {
              weekday: "long",
            })
            .toLowerCase(),
        });
      }
    }

    const countedHolidays = schedules?.map((item) => {
      const holidayCount = holidaysDate?.reduce(
        (count, holiday) =>
          holiday?.dayOfWeek && item?.schedule.includes(holiday?.dayOfWeek)
            ? count + 1
            : count,
        0
      );
      return { id: item.id, holidayCount };
    });

    for (const employeeId of ids) {
      const matchingLogs = filteredLogs.filter(
        (log) => log?.employee?.id === employeeId
      );

      const count = matchingLogs?.length;
      let holidayList = [];
      let suspension = [];
      const totalHolidays = countedHolidays.find(
        (item) => item?.id === employeeId
      );
      holidayList.push(totalHolidays);

      const totalHolidaysCount = holidayList.reduce((sum, item) => {
        return sum + (item?.holidayCount || 0);
      }, 0);
      const totalLeaveDuration = filterLeaves.reduce(
        (sum, duration) => sum + duration,
        0
      );

      const totalSuspension = countedSuspension.find(
        (item) => item?.id === employeeId
      );

      suspension.push(totalSuspension);
      const totalSuspensionCount = suspension.reduce((sum, item) => {
        return sum + (item?.suspensionList ?? 0);
      }, 0);

      const totalDeducCount =
        count + totalHolidaysCount + totalLeaveDuration + totalSuspensionCount;

      const employeeWorkingDays = workingDaysCount.find(
        (day) => day?.id === employeeId
      );

      const workDays = employeeWorkingDays?.workingDays || 0;
      const totalCount = workDays - totalDeducCount;

      logsByEmployee.push({ id: employeeId, absences: 0 });
    }

    this.view.setState({
      absences: logsByEmployee,
      counts: count,
      holidaysCount: holidaysDate.length,
      workingDaysCount: workingDaysCount?.[0]?.workingDays ?? 0,
      weekEndsOff: weekEndsOff?.[0]?.excludedDays ?? 0,
    });
  }

  async getMinsDeducted() {
    const { objects1, startDate, endDate } = this.view.props;

    const start = new Date(startDate);
    const end = new Date(endDate);

    const convertedStart = start.toISOString();
    const convertedEnd = new Date(
      end.getTime() + 24 * 60 * 60 * 1000
    ).toISOString();

    let ids = [];
    for (const employee of objects1) {
      ids.push(employee.id);
    }

    const employeeLogs = await findObjectUseCase().execute(
      "daily_time_record",
      {
        where: {
          "employee.id": { $in: ids },
          timeRecStats: { $in: ["LATE", "UNDERTIME"] },
          date: {
            $gte: convertedStart,
            $lt: convertedEnd,
          },
        },
      }
    );

    const logsByEmployee = {};
    for (const log of employeeLogs) {
      const empId = log.employee.id;
      if (!logsByEmployee[empId]) {
        logsByEmployee[empId] = [];
      }
      logsByEmployee[empId].push(log);
    }

    const result = [];

    for (const employee of objects1) {
      const employeeId = employee.id;
      const schedule = employee?.selectedSchedule?.scheduleArray ?? [];
      const logs = logsByEmployee[employeeId] || [];
      const startingDate = new Date(employee?.selectedSchedule?.startingDate);

      const scheduleName = schedule[0]?.day || "";
      const selectedOption = employee?.selectedSchedule?.selectedOption || "";

      const graveyardMatch = scheduleName.match(
        /^Graveyard (\d+)days Working, (\d+)days off$/
      );
      const regularMatch = scheduleName.match(
        /^Regular (\d+)days Working, (\d+)days off$/
      );
      const plainCycleMatch = scheduleName.match(
        /^(\d+)days Working, (\d+)days off$/
      );

      const twoDayGraveyardMatch = scheduleName.match(/^(\w+) - (\w+)$/);

      const alternateMWFMatch = selectedOption === "Alternate (MWF)";
      const alternateTTHSMatch = selectedOption === "Alternate (TTHS)";
      const isAlternateSchedule = alternateMWFMatch || alternateTTHSMatch;

      const workingDaysAlt = alternateMWFMatch
        ? ["Monday", "Wednesday", "Friday"]
        : alternateTTHSMatch
        ? ["Tuesday", "Thursday", "Saturday"]
        : [];

      const matchedSchedule = graveyardMatch || regularMatch || plainCycleMatch;
      const isShiftCycleSchedule = !!matchedSchedule;
      const workingDays = matchedSchedule
        ? parseInt(matchedSchedule[1], 10)
        : 0;
      const cycleLength = matchedSchedule
        ? workingDays + parseInt(matchedSchedule[2], 10)
        : 0;
      const isGraveyard = !!graveyardMatch;
      const isTwoDayGraveyard = !!twoDayGraveyardMatch;

      let totalDeductedMins = 0;

      for (const log of logs) {
        const logDate = new Date(log?.date);
        const dayName = this.getDayName(logDate);

        const daysSinceStart = Math.floor(
          (logDate - startingDate) / (1000 * 60 * 60 * 24)
        );

        if (isShiftCycleSchedule) {
          if (daysSinceStart < 0) continue;

          const cycleDay = daysSinceStart % cycleLength;
          if (cycleDay >= workingDays) continue;

          const actualTimeInMin = this.toMinutes(
            isGraveyard ? log?.timePmIn : log?.timeIn
          );
          const actualTimeOutMin = this.toMinutes(
            isGraveyard ? log?.timeAmOut : log?.timeOut,
            isGraveyard
          );

          const schedTimeInMin = this.toMinutes(schedule[0]?.timein);
          const schedTimeOutMin = this.toMinutes(schedule[0]?.timeout);

          const late = Math.max(actualTimeInMin - schedTimeInMin, 0);
          const undertime = Math.max(schedTimeOutMin - actualTimeOutMin, 0);

          totalDeductedMins += late + undertime;
        } else if (isTwoDayGraveyard) {
          const firstDay = twoDayGraveyardMatch[1];
          const secondDay = twoDayGraveyardMatch[2];

          const schedTimeInMin = this.toMinutes(schedule[0]?.timein);
          const schedTimeOutMin = this.toMinutes(schedule[0]?.timeout, true);

          if (dayName === firstDay) {
            const timeInMin = this.toMinutes(log?.timePmIn);
            const late =
              timeInMin > schedTimeInMin ? timeInMin - schedTimeInMin : 0;
            totalDeductedMins += late;
          }

          if (dayName === secondDay) {
            const timeOutMin = this.toMinutes(log?.timeAmOut, true);
            const undertime =
              timeOutMin < schedTimeOutMin ? schedTimeOutMin - timeOutMin : 0;
            totalDeductedMins += undertime;
          }
        } else if (isAlternateSchedule) {
          if (!workingDaysAlt.includes(dayName)) continue;

          const actualTimeInMin = this.toMinutes(log?.timeIn);
          const actualTimeOutMin = this.toMinutes(log?.timeOut);

          const schedTimeInMin = this.toMinutes(schedule[0]?.timein);
          const schedTimeOutMin = this.toMinutes(schedule[0]?.timeout);

          const late = Math.max(actualTimeInMin - schedTimeInMin, 0);
          const undertime = Math.max(schedTimeOutMin - actualTimeOutMin, 0);

          totalDeductedMins += late + undertime;
        } else {
          const daySchedule = schedule.find((s) => s?.day === dayName);
          if (!daySchedule) continue;

          const actualTimeInMin = this.toMinutes(log?.timeIn);
          const actualTimeOutMin = this.toMinutes(log?.timeOut);

          const schedTimeInMin = this.toMinutes(daySchedule?.timein);
          const schedTimeOutMin = this.toMinutes(daySchedule?.timeout);

          const late = Math.max(actualTimeInMin - schedTimeInMin, 0);
          const undertime = Math.max(schedTimeOutMin - actualTimeOutMin, 0);

          totalDeductedMins += late + undertime;
        }
      }

      result.push({
        employeeId,
        totalDeductedMins,
      });
    }
    return result;
  }

  getDayName(dateStr) {
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-US", { weekday: "long" });
  }

  toMinutes(timeStr, isTimeOut = false) {
    if (!timeStr) return 0;
    const [hour, minute] = timeStr.split(":").map(Number);
    let total = hour * 60 + minute;

    if (!isTimeOut && total < 300) {
      return total + 1440;
    }

    return total;
  }

  getTimeDifference = (params) => {
    const { timeStr1, timeStr2 } = params;
    const parseTime = (timeStr) => {
      if (timeStr === "--:--" || !timeStr) return null;
      const [time, modifier] = timeStr.split(" ");
      let [hours, minutes, seconds] = time.split(":").map(Number);
      if (!seconds) seconds = 0;

      if (modifier === "PM" && hours < 12) hours += 12;
      if (modifier === "AM" && hours === 12) hours = 0;

      return { hours, minutes, seconds };
    };

    const time1 = parseTime(timeStr1);
    const time2 = parseTime(timeStr2);
    if (!time1 || !time2) return 0;

    const time1InMinutes = time1.hours * 60 + time1.minutes;
    const time2InMinutes = time2.hours * 60 + time2.minutes;

    return time1InMinutes - time2InMinutes;
  };

  getDeductedInRange = (params) => {
    const { employeesMins, startDate, endDate } = params;

    const totalMinsByEmployee = {};

    const normalizedStartDate = new Date(startDate.setHours(0, 0, 0, 0));
    const normalizedEndDate = new Date(endDate.setHours(23, 59, 59, 999));

    employeesMins.forEach((record) => {
      const recordDate = new Date(record.date);
      const normalizedRecordDate = new Date(recordDate.setHours(0, 0, 0, 0));

      if (
        normalizedRecordDate >= normalizedStartDate &&
        normalizedRecordDate <= normalizedEndDate
      ) {
        if (!totalMinsByEmployee[record.id]) {
          totalMinsByEmployee[record.id] = {
            totalMinsDeducted: 0,
            totalDaysDeducted: 0,
          };
        }

        totalMinsByEmployee[record.id].totalMinsDeducted +=
          record.totalMinsDeducted || 0;
        totalMinsByEmployee[record.id].totalDaysDeducted +=
          record.totalDaysDeducted || 0;
      }
    });

    return totalMinsByEmployee;
  };

  async getAssignAirport() {
    const { objects1 } = this.view.props;

    let ids = objects1.map((emp) => emp.id);

    const airportAssigned = await findObjectUseCase().execute(
      "airport_assign",
      {
        where: {
          "employees.id": { $in: ids },
        },
      }
    );

    const result = {};

    for (const item of airportAssigned) {
      const start = new Date(item.startDate);
      const end = new Date(item.endDate);
      const timeDiff = Math.abs(end - start);
      const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24)) + 1;

      for (const emp of item?.employees) {
        if (ids.includes(emp.id)) {
          result[emp.id] = days;
        }
      }
    }

    this.view.setState({ airportAssignDays: result });
  }
}

export default PayrollFormPresenter;
